module.exports = __webpack_public_path__ + "img/200.9852b155.jpg";